import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { requests } from '../../../core/ajax'
import { feedback } from '../../../core/feedback'

const ERR_CODE_NOT_CONFIRMED = 3503

export const useLoginCalls = () => {
  const { formatMessage } = useIntl()
  // const dispatch = useDispatch()

  const noResponseError = () =>
    feedback('error', formatMessage({ id: 'calls.responseless.error.description' }))
  const defaultError = () => {}

  const loginCall = useCallback(
    (payload) =>
      new Promise((resolve, reject) => {
        requests.login(payload)
          .then((response) => {
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                if (response.data.code === ERR_CODE_NOT_CONFIRMED) {
                  return reject('inactive_user')
                }
                break
              default:
                defaultError()
            }
            return reject(response)
          })
      }),
    [] // eslint-disable-line
  )

  const sendRecoveryCode = useCallback(
    (payload) =>
      new Promise((resolve, reject) => {
        requests.recover(payload)
          .then((response) => {
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [], // eslint-disable-line
  )

  const confirmRecovery = useCallback(
    (payload) =>
      new Promise((resolve, reject) => {
        requests.confirm(payload)
          .then((response) => {
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [], // eslint-disable-line
  )

  return {
    loginCall,
    sendRecoveryCode,
    confirmRecovery,
  }
}
